import {
  CustomerDetailsArrow,
  CustomerDetailsLabel,
  CustomerDetailsRow,
  CustomerDetailsText,
} from './CustomerDetailsField.styles';

const CustomerDetailsField = (props) => {
  const { label, text, testId } = props;

  return (
    <CustomerDetailsRow data-testid={testId}>
      <CustomerDetailsLabel>{label}</CustomerDetailsLabel>
      <CustomerDetailsArrow>→</CustomerDetailsArrow>
      <CustomerDetailsText>{text}</CustomerDetailsText>
    </CustomerDetailsRow>
  );
};

export default CustomerDetailsField;
